import GraphicUtils from "../../../../../../../utils/graphic-utils.js";
import ReportUtils from "../../../../../../../utils/report-utils.js";

export function exportMainList(list){
  const headers = ["ID", "Visibilidade", "Monitoramento", "Alarmes", "Status", "Natureza", "Placa", "Data/hora inicial",
    "Dia da semana", "Data/hora final", "Logradouro", "Bairro", "Cidade", "Latitude", "Longitude", "Descrição"]
  const rows = list.map(item => [
    item.id,
    item.visibility,
    item.monitoring,
    item.alarms,
    translateStatus(item.status),
    item.reason,
    item.plate,
    item.dt_ini,
    item.dow_ini,
    item.dt_end,
    item.address,
    item.neighborhood,
    item.city,
    item.latitude,
    item.longitude,
    item.description
  ]);

  ReportUtils.createExportableTable(headers, rows, "Lista de mapeamento");
}

function translateStatus(value) {
  const translateObj = {
    ACTIVE: "Ativa",
    CONCLUDED: "Concluída"
  }
  return translateObj[value]
}

export const statusLabels = [
  "Ocorrências",
  "Monitoramentos",
  "Alarmes"
]
export function exportCards(data) {
  const values = [data?.total_occ ?? 0, data?.monitoring ?? 0, data?.alarms ?? 0];
  ReportUtils.createExportableTable(statusLabels, values, "Cards");
}

export function exportOccByNeighborhoodAndPeriodTable(data){
  const labels = ["Bairro", "Madrugada", "Manhã", "Tarde", "Noite", "Total"];
  const rows = data.map(item => [
    item.neighborhood,
    item.dawn,
    item.morning,
    item.afternoon,
    item.night,
    item.total
  ])

  data?.length && ReportUtils.createExportableTable(labels, rows, "Por bairro e período");
}

export function createWeekAnalysisChart(data, reportInfo){
  const allLabels = [];
  const allValues = [];

  for (const item of data) {
    allLabels.push(formatDate(item.week));
    allValues.push(item.qty);
  }

  GraphicUtils.lineChart(reportInfo.reportId, [["Ocorrências por semana", ...allValues.slice(0,10)]], allLabels.slice(0,10));
  data && data.length > 0 && ReportUtils.createExportableTable(allLabels, allValues, `Ocorrências por semana`,  null, ["Semana", "Quantidade"]);
}

function formatDate (date){
  if(!date) return "";
  if(date.includes("-")){
    const [y,m,d] = date.split("-");
    return `${d}/${m}/${y}`
  }
  return date;
}

export const reportsInfo = {
  occStatus: {
    reportName: "Status das ocorrências",
    reportId: "occ-status"
  },
  occPeriodDistribution: {
    reportName: "Ocorrências por período",
    reportId : "occ-period-distribution"
  },
  occByNeighborhoodAndPeriod: {
    reportName: "Ocorrências por bairro e período",
    reportId : "occ-by-neighborhood-and-period"
  },
  weekAnalysis: {
    reportName: "Ocorrências por semana",
    reportId : "week-analysis"
  },
  dayWeekAnalysis: {
    reportName: "Ocorrências por dia da semana",
    reportId : "day-analysis"
  },
  hourAnalysis: {
    reportName: "Ocorrências por intervalo de horas",
    reportId : "hour-analysis"
  },
  alarmsByCapturePlace: {
    reportName: "Alarmes de veículo por ponto de coleta",
    reportId : "alarms-by-capture-place"
  }
}


